export default class SyncContext<T> {
  private stack: T[] = [];

  constructor(initialValue: T) {
    this.stack.push(initialValue);
  }

  current(): T {
    // Initial value is always present
    return this.stack.at(-1)!;
  }

  run<R>(value: T, fn: () => R): R {
    this.stack.push(value);
    try {
      return fn();
    } finally {
      this.stack.pop();
    }
  }
}
